import { Component, OnInit, OnChanges, Input, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { EventsService } from 'src/app/services/events-service/events.service';
import { EMPTY, Subscription } from 'rxjs';
import { catchError } from 'rxjs/internal/operators/catchError';
import { tap } from 'rxjs/internal/operators/tap';

@Component({
  selector: 'app-events-event-providers-card',
  templateUrl: './events-event-providers-card.component.html',
  styleUrls: ['./events-event-providers-card.component.scss']
})
export class EventsEventProvidersCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() alert;
  @Input() mailProviders;
  basicDataForm = new FormGroup({
    selectedMailProvider: new FormControl(null, Validators.required),
  });
  updateAlertMailConfigProviderSubscription: Subscription;

  constructor(private eventsService: EventsService,
              private snackbarService: SnackBarService) { }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.alert && this.mailProviders) {
      this.resetForm();
    }
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      selectedMailProvider: this.alert.companyMailConfig
    });
  }

  public updateMailConfigProvider(event) {
    this.updateAlertMailConfigProviderSubscription = this.eventsService.updateAlertMailConfigProvider(
      this.alert.InternalId,
      this.getSelectedMailProvider()
    ).pipe(
      tap(o => this.eventsService.refreshAlert()),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public getSelectedMailProvider() {
    if (this.mailProviders.length === 1) {
      return this.mailProviders[0].InternalId;
    } else {
      if (this.basicDataForm.get('selectedMailProvider').value) {
        return this.basicDataForm.get('selectedMailProvider').value.InternalId;
      } else {
        return null;
      }
    }
  }

  public setSelectedMailProvider() {
    if (this.alert && this.alert.CompanyMailConfig && this.mailProviders && this.mailProviders.length > 0) {
      for (const mailProvider of this.mailProviders) {
        if (mailProvider.InternalId === this.alert.CompanyMailConfig.InternalId) {
          return mailProvider;
        }
      }
    } else {
      return null;
    }
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }

  ngOnDestroy() {
    if (this.updateAlertMailConfigProviderSubscription) { this.updateAlertMailConfigProviderSubscription.unsubscribe(); }
  }
}
